/**
 * ECharts 공통 — 다크모드 대응 (qnnp-react-ts theme.ts 승계, ECharts 단일화)
 */
import echarts from "src/lib/echarts";
import { useThemeStore } from "src/stores/ThemeStore";
import { darkTheme } from "./darkTheme";

let themeRegistered = false;

/** 앱 시작 시 1회 호출 */
export const registerChartTheme = () => {
  if (themeRegistered) return;
  echarts.registerTheme("app-dark", darkTheme as any);
  themeRegistered = true;
};

/** 컴포넌트에서 테마 이름 조회 */
export const useChartTheme = (): "app-dark" | undefined => {
  const isDarkMode = useThemeStore((s) => s.isDarkMode);
  return isDarkMode ? "app-dark" : undefined;
};

export const tooltipTheme = (isDark: boolean) => ({
  backgroundColor: isDark ? "#1f1f1f" : "#fff",
  borderColor: isDark ? "#444" : "#e5e5e5",
  textStyle: { color: isDark ? "#ddd" : "#333", fontSize: 13 },
  padding: [10, 14] as [number, number],
  extraCssText: "border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);",
});

/** 도넛차트 공통 옵션 (레이블/툴팁 스타일 통일) */
export const donutBaseOption = (isDark: boolean) => ({
  tooltip: {
    trigger: "item" as const,
    ...tooltipTheme(isDark),
    formatter: (p: any) =>
      `${p.name}<br/>${p.marker} ${Math.round(p.value).toLocaleString()}원 (${p.percent}%)`,
  },
  legend: {
    orient: "vertical" as const,
    right: 4,
    top: "center",
    textStyle: { color: isDark ? "#aaa" : "#666", fontSize: 11 },
    itemGap: 8,
    formatter: (name: string) => (name.length > 8 ? `${name.slice(0, 8)}…` : name),
  },
  series: [] as any[],
});
